"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.BUTTON_DISABLED = exports.BUTTON_CONTENT = exports.BUTTON_CENTER = exports.BUTTON = exports.BUTTON_CONTAINER_DISABLED = exports.BUTTON_CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    borderColor = function borderColor(a) {
  var b = a.selected,
      c = a.darkMode;
  return b ? _vars.COLOURS.cyan.jungleGreen.monkey : c ? _vars.COLOURS.mono.white : _vars.COLOURS.grey.mischka.russian;
},
    BUTTON_CONTAINER = function BUTTON_CONTAINER(a) {
  var b = a.selected,
      c = a.darkMode,
      d = a.disabled;
  return (0, _cxs["default"])({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    ":hover": b || d ? {} : {
      " > .radio-button__button": {
        borderColor: c ? void 0 : _vars.COLOURS.grey.regent,
        borderWidth: c ? "2px" : void 0
      }
    }
  });
};

exports.BUTTON_CONTAINER = BUTTON_CONTAINER;
var BUTTON_CONTAINER_DISABLED = (0, _cxs["default"])({
  cursor: "default"
});
exports.BUTTON_CONTAINER_DISABLED = BUTTON_CONTAINER_DISABLED;

var BUTTON = function BUTTON(a) {
  var b = a.selected,
      c = a.darkMode;
  return (0, _cxs["default"])({
    border: "".concat(b ? 2 : 1, "px solid ").concat(borderColor({
      selected: b,
      darkMode: c
    })),
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "20px",
    minHeight: "20px",
    position: "relative",
    zIndex: 0,
    boxSizing: "border-box",
    background: c ? _vars.COLOURS.mono.white25 : _vars.COLOURS.grey.athens.parthenon
  });
};

exports.BUTTON = BUTTON;
var BUTTON_CENTER = (0, _cxs["default"])({
  background: _vars.COLOURS.cyan.jungleGreen.monkey,
  borderRadius: "50%",
  width: "12px",
  minWidth: "12px",
  height: "12px",
  minHeight: "12px",
  position: "relative",
  zIndex: 1
});
exports.BUTTON_CENTER = BUTTON_CENTER;
var BUTTON_CONTENT = (0, _cxs["default"])({
  marginLeft: "20px",
  display: "flex",
  alignItems: "center",
  " > .icon-container": {
    marginRight: "20px"
  }
});
exports.BUTTON_CONTENT = BUTTON_CONTENT;
var BUTTON_DISABLED = (0, _cxs["default"])({
  background: "#f2f2f2",
  cursor: "default",
  pointerEvents: "none"
});
exports.BUTTON_DISABLED = BUTTON_DISABLED;